module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rxeob-table"
  }, [_c('b-table', {
    ref: "headers",
    attrs: {
      "data": [{}],
      "mobile-cards": false,
      "icon-pack": "fa",
      "backend-sorting": true
    },
    on: {
      "sort": _vm.tableSorter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": _vm.getDefault('column_medication'),
            "field": "Ln",
            "width": "275",
            "sortable": ""
          }
        }), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.getDefault('column_copay'),
            "field": "Price.MemberCost",
            "width": "100",
            "sortable": "",
            "numeric": ""
          }
        }), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.getDefault('column_tier'),
            "field": "Tier.Tier",
            "width": "200",
            "sortable": ""
          }
        }), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.getDefault('column_indicator'),
            "field": "Indicators",
            "width": "175"
          }
        }), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "width": "50"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('div', {
    model: {
      value: (_vm.componentKey),
      callback: function($$v) {
        _vm.componentKey = $$v
      },
      expression: "componentKey"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasResults('1')),
      expression: "hasResults('1')"
    }]
  }, [_c('div', {
    staticClass: "apollo-divider"
  }, [_c('div', [_c('span', {
    staticClass: "header",
    on: {
      "click": function($event) {
        return _vm.collapseSection('1')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getDefault(_vm.tableData["1"].ResultType.StrategyType)) + "\n          "), _c('span', {
    staticClass: "collapse-toggle-wrapper"
  }, [_c('i', {
    staticClass: "fas fa-chevron-up collapse-toggle",
    class: {
      collapsed: _vm.collapsed['1']
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "slide-up",
    class: {
      'slide-up-to': _vm.collapsed['1']
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.tableData['1'].ResultsFiltered,
      "hoverable": true,
      "mobile-cards": false,
      "row-class": _vm.getCssClasses,
      "selected": _vm.currentResult
    },
    on: {
      "click": _vm.resultClick,
      "update:selected": function($event) {
        _vm.currentResult = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "Medication",
            "width": "275"
          }
        }, [_c('b-tooltip', {
          staticClass: "is-hidden-mobile",
          attrs: {
            "label": props.row.BrandGenericEquivalent,
            "size": "is-small",
            "multilined": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.Ln) + "\n                ")]), _vm._v(" "), _c('span', {
          staticClass: "is-hidden-tablet"
        }, [_vm._v(_vm._s(props.row.Ln))])], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Copay",
            "width": "100",
            "numeric": ""
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")((props.row.TierOverridden ? props.row.Price.MemberCostOverride : props.row.Price.MemberCost))))])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Tier",
            "width": "200"
          }
        }, [(_vm.tableData[1].healthplanid == 31 || _vm.tableData[1].healthplanid == 74 || _vm.tableData[1].healthplanid == 76) ? _c('span', [_vm._v(_vm._s((props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.TierName))))]) : _vm._e(), _vm._v(" "), (_vm.tableData[1].healthplanid != 31 && _vm.tableData[1].healthplanid != 74 && _vm.tableData[1].healthplanid != 76) ? _c('span', [_vm._v(_vm._s((props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.Tier + " / " + props.row.Tier.TierName))))]) : _vm._e()]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Indicators",
            "width": "175"
          }
        }, _vm._l((props.row.Indicators), function(i) {
          return _c('span', {
            staticClass: "indicator"
          }, [_c('b-tooltip', {
            staticClass: "is-hidden-mobile",
            attrs: {
              "label": i.IndicatorDescription,
              "size": "is-large",
              "multilined": ""
            }
          }, [_vm._v("\n                " + _vm._s(i.IndicatorCode) + "\n              ")]), _vm._v(" "), _c('span', {
            staticClass: "is-hidden-tablet",
            attrs: {
              "size": "is-large",
              "multilined": ""
            }
          }, [_vm._v("\n                " + _vm._s(i.IndicatorCode) + "\n              ")])], 1)
        }), 0), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "width": "50"
          }
        }, [_c('b-tooltip', {
          attrs: {
            "label": _vm.getDefault('more_information'),
            "position": "is-left"
          }
        }, [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": "info-circle"
          }
        })], 1)], 1)]
      }
    }, {
      key: "header",
      fn: function(props) {
        return undefined
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    model: {
      value: (_vm.componentKey),
      callback: function($$v) {
        _vm.componentKey = $$v
      },
      expression: "componentKey"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasResults('2')),
      expression: "hasResults('2')"
    }]
  }, [_c('div', {
    staticClass: "apollo-divider"
  }, [_c('div', [_c('span', {
    staticClass: "header",
    on: {
      "click": function($event) {
        return _vm.collapseSection('2')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getDefault(_vm.tableData["2"].ResultType.StrategyType)) + "\n          "), _c('span', {
    staticClass: "collapse-toggle-wrapper"
  }, [_c('i', {
    staticClass: "fas fa-chevron-up collapse-toggle",
    class: {
      collapsed: _vm.collapsed['2']
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "slide-up",
    class: {
      'slide-up-to': _vm.collapsed['2']
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.tableData['2'].ResultsFiltered,
      "hoverable": true,
      "mobile-cards": false,
      "row-class": _vm.getCssClasses,
      "selected": _vm.currentResult
    },
    on: {
      "click": _vm.resultClick,
      "update:selected": function($event) {
        _vm.currentResult = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "Medication",
            "width": "275"
          }
        }, [_c('b-tooltip', {
          staticClass: "is-hidden-mobile",
          attrs: {
            "label": props.row.BrandGenericEquivalent,
            "size": "is-small",
            "multilined": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.Ln) + "\n                ")]), _vm._v(" "), _c('span', {
          staticClass: "is-hidden-tablet"
        }, [_vm._v(_vm._s(props.row.Ln))])], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Copay",
            "width": "100",
            "numeric": ""
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")((props.row.TierOverridden ? props.row.Price.MemberCostOverride : props.row.Price.MemberCost))))])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Tier",
            "width": "200"
          }
        }, [(_vm.tableData[1].healthplanid == 31 || _vm.tableData[1].healthplanid == 74 || _vm.tableData[1].healthplanid == 76) ? _c('span', [_vm._v(_vm._s((props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.TierName))))]) : _vm._e(), _vm._v(" "), (_vm.tableData[1].healthplanid != 31 && _vm.tableData[1].healthplanid != 74 && _vm.tableData[1].healthplanid != 76) ? _c('span', [_vm._v(_vm._s((props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.Tier + " / " + props.row.Tier.TierName))))]) : _vm._e()]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Indicators",
            "width": "175"
          }
        }, _vm._l((props.row.Indicators), function(i) {
          return _c('span', {
            staticClass: "indicator"
          }, [_c('b-tooltip', {
            staticClass: "is-hidden-mobile",
            attrs: {
              "label": i.IndicatorDescription,
              "size": "is-large",
              "multilined": ""
            }
          }, [_vm._v("\n                " + _vm._s(i.IndicatorCode) + "\n                ")]), _vm._v(" "), _c('span', {
            staticClass: "is-hidden-tablet",
            attrs: {
              "size": "is-large",
              "multilined": ""
            }
          }, [_vm._v("\n                " + _vm._s(i.IndicatorCode) + "\n              ")])], 1)
        }), 0), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "width": "50"
          }
        }, [_c('b-tooltip', {
          attrs: {
            "label": _vm.getDefault('more_information'),
            "position": "is-left"
          }
        }, [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": "info-circle"
          }
        })], 1)], 1)]
      }
    }, {
      key: "header",
      fn: function(props) {
        return undefined
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    model: {
      value: (_vm.componentKey),
      callback: function($$v) {
        _vm.componentKey = $$v
      },
      expression: "componentKey"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasResults('3')),
      expression: "hasResults('3')"
    }]
  }, [_c('div', {
    staticClass: "apollo-divider"
  }, [_c('div', [_c('span', {
    staticClass: "header",
    on: {
      "click": function($event) {
        return _vm.collapseSection('3')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getDefault(_vm.tableData["3"].ResultType.StrategyType)) + "\n          "), _c('span', {
    staticClass: "collapse-toggle-wrapper"
  }, [_c('i', {
    staticClass: "fas fa-chevron-up collapse-toggle",
    class: {
      collapsed: _vm.collapsed['3']
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "slide-up",
    class: {
      'slide-up-to': _vm.collapsed['3']
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.tableData['3'].ResultsFiltered,
      "hoverable": true,
      "mobile-cards": false,
      "row-class": _vm.getCssClasses,
      "selected": _vm.currentResult
    },
    on: {
      "click": _vm.resultClick,
      "update:selected": function($event) {
        _vm.currentResult = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "Medication",
            "width": "275"
          }
        }, [_c('b-tooltip', {
          staticClass: "is-hidden-mobile",
          attrs: {
            "label": props.row.BrandGenericEquivalent,
            "size": "is-small",
            "multilined": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.Ln) + "\n                ")]), _vm._v(" "), _c('span', {
          staticClass: "is-hidden-tablet"
        }, [_vm._v(_vm._s(props.row.Ln))])], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Copay",
            "width": "100",
            "numeric": ""
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")((props.row.TierOverridden ? props.row.Price.MemberCostOverride : props.row.Price.MemberCost))))])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Tier",
            "width": "200"
          }
        }, [(_vm.tableData[1].healthplanid == 31 || _vm.tableData[1].healthplanid == 74 || _vm.tableData[1].healthplanid == 76) ? _c('span', [_vm._v(_vm._s((props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.TierName))))]) : _vm._e(), _vm._v(" "), (_vm.tableData[1].healthplanid != 31 && _vm.tableData[1].healthplanid != 74 && _vm.tableData[1].healthplanid != 76) ? _c('span', [_vm._v(_vm._s((props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.Tier + " / " + props.row.Tier.TierName))))]) : _vm._e()]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Indicators",
            "width": "175"
          }
        }, _vm._l((props.row.Indicators), function(i) {
          return _c('span', {
            staticClass: "indicator"
          }, [_c('b-tooltip', {
            staticClass: "is-hidden-mobile",
            attrs: {
              "label": i.IndicatorDescription,
              "size": "is-large",
              "multilined": ""
            }
          }, [_vm._v("\n                " + _vm._s(i.IndicatorCode) + "\n                ")]), _vm._v(" "), _c('span', {
            staticClass: "is-hidden-tablet",
            attrs: {
              "size": "is-large",
              "multilined": ""
            }
          }, [_vm._v("\n                " + _vm._s(i.IndicatorCode) + "\n              ")])], 1)
        }), 0), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "width": "50"
          }
        }, [_c('b-tooltip', {
          attrs: {
            "label": _vm.getDefault('more_information'),
            "position": "is-left"
          }
        }, [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": "info-circle"
          }
        })], 1)], 1)]
      }
    }, {
      key: "header",
      fn: function(props) {
        return undefined
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    model: {
      value: (_vm.componentKey),
      callback: function($$v) {
        _vm.componentKey = $$v
      },
      expression: "componentKey"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasResults('4')),
      expression: "hasResults('4')"
    }]
  }, [_c('div', {
    staticClass: "apollo-divider"
  }, [_c('div', [_c('span', {
    staticClass: "header",
    on: {
      "click": function($event) {
        return _vm.collapseSection('4')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getDefault(_vm.tableData["4"].ResultType.StrategyType)) + "\n          "), _c('span', {
    staticClass: "collapse-toggle-wrapper"
  }, [_c('i', {
    staticClass: "fas fa-chevron-up collapse-toggle",
    class: {
      collapsed: _vm.collapsed['4']
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "slide-up",
    class: {
      'slide-up-to': _vm.collapsed['4']
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.tableData['4'].ResultsFiltered,
      "hoverable": true,
      "mobile-cards": false,
      "row-class": _vm.getCssClasses,
      "selected": _vm.currentResult
    },
    on: {
      "click": _vm.resultClick,
      "update:selected": function($event) {
        _vm.currentResult = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "Medication",
            "width": "275"
          }
        }, [_c('b-tooltip', {
          staticClass: "is-hidden-mobile",
          attrs: {
            "label": props.row.BrandGenericEquivalent,
            "size": "is-small",
            "multilined": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.Ln) + "\n                ")]), _vm._v(" "), _c('span', {
          staticClass: "is-hidden-tablet"
        }, [_vm._v(_vm._s(props.row.Ln))])], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Copay",
            "width": "100",
            "numeric": ""
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")((props.row.TierOverridden ? props.row.Price.MemberCostOverride : props.row.Price.MemberCost))))])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Tier",
            "width": "200"
          }
        }, [(_vm.tableData[1].healthplanid == 31 || _vm.tableData[1].healthplanid == 74 || _vm.tableData[1].healthplanid == 76) ? _c('span', [_vm._v(_vm._s((props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.TierName))))]) : _vm._e(), _vm._v(" "), (_vm.tableData[1].healthplanid != 31 && _vm.tableData[1].healthplanid != 74 && _vm.tableData[1].healthplanid != 76) ? _c('span', [_vm._v(_vm._s((props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.Tier + " / " + props.row.Tier.TierName))))]) : _vm._e()]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Indicators",
            "width": "175"
          }
        }, _vm._l((props.row.Indicators), function(i) {
          return _c('span', {
            staticClass: "indicator"
          }, [_c('b-tooltip', {
            staticClass: "is-hidden-mobile",
            attrs: {
              "label": i.IndicatorDescription,
              "size": "is-large",
              "multilined": ""
            }
          }, [_vm._v("\n                " + _vm._s(i.IndicatorCode) + "\n              ")]), _vm._v(" "), _c('span', {
            staticClass: "is-hidden-tablet",
            attrs: {
              "size": "is-large",
              "multilined": ""
            }
          }, [_vm._v("\n                " + _vm._s(i.IndicatorCode) + "\n              ")])], 1)
        }), 0), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "width": "50"
          }
        }, [_c('b-tooltip', {
          attrs: {
            "label": _vm.getDefault('more_information'),
            "position": "is-left"
          }
        }, [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": "info-circle"
          }
        })], 1)], 1)]
      }
    }, {
      key: "header",
      fn: function(props) {
        return undefined
      }
    }])
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335c355a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrugSearchTable.vue
// module id = 514
// module chunks = 5